import React, { useEffect, useState } from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setFields } from './GeneralSlice';
import Label from '../../../components/label/Label';
import { LABEL_WEIGHT } from '../../../components/label/constants';
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox';
import CalendarInputWDateFormat from '../../../components/input/calendarinput/CalendarInputWDateFormat';
import TextInput from '../../../components/input/textinput/TextInput';
import Button from '../../../components/button/Button';
import { getGeneralSettings, saveIsEmailOptOut, saveIsRecipientTinUnMask, updateGeneralInfo, updateMaskUnmaskOptions, updateScheduleDate, updateSupportMail, saveIsFormsRoutingToUSPSMail, getSalesTaxExemptionStatus } from './GeneralSaga';
import Loadable from '../../../components/loadable/Loadable';
import styles from './General.styles';
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator'
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants';
import Config from '../../../config.web';
import { GENERAL_SETTINGS } from './constant';
import FormAttachmentUpload from '../../components/formattachmentupload.js/FormAttachmentUpload';

export default function General() {
	const dispatch = useDispatch();
	const { fields, loadingState , salesTaxAdminStatus} = useSelector((state) => state[componentKey])
	const [attachments, setAttachments] = useState('');

	useEffect(() => {
		dispatch(getGeneralSettings());
	}, [])

	/* useEffect(() => {
		dispatch(getSalesTaxExemptionStatus());
	}, [attachments]) */

	const handleCheckChange = (e, option, key) => {
		let updatedFileds = JSON.parse(JSON.stringify(fields))
		updatedFileds = {
			...updatedFileds, [key]: updatedFileds[key].map(option => {
				if (option.Field === e.target.name) {
					return { ...option, Value: e.target.checked.toString() }
				}
				return option;
			})
		}
		dispatch(setFields(updatedFileds))
	}

	const handleInputChange = (e, option, key) => {
		let name;
		let value;
		if (e.target?.name === undefined) {
			name = option.Field
			value = e
		}
		else {
			name = e.target.name
			value = e.target.value
		}
		let updatedFileds = JSON.parse(JSON.stringify(fields))

		updatedFileds = {
			...updatedFileds, [key]: updatedFileds[key].map(option => {
				if (option.Field === name) {
					return { ...option, Value: value }
				}
				return option;
			})
		}
		dispatch(setFields(updatedFileds))
	}

	const getInput = (option, key) => {
		switch (option.Type) {
			case 'Boolean':
				return <Checkbox name={option.Field} disabled={option.IsDisabled} checked={option.Value === "true" || false} onChangeCb={(e) => handleCheckChange(e, option, key)} />
			case 'Date':
				return <CalendarInputWDateFormat disabled={option.IsDisabled} value={option.Value} onChangeCb={(e) => handleInputChange(e, option, key)} />
			case 'Email':
				return <TextInput
					name={option.Field}
					containerStyles={styles.fieldMaxWidth}
					disabled={option.IsDisabled}
					value={option.Value}
					onChangeCb={(e) => handleInputChange(e, option, key)}
				/>
		}
	}

	const handleSubmit = (key) => {
		const params = fields[key].reduce(
			(obj, item) => Object.assign(obj, { [item.Field]: item?.Value ?? "" }), {});

		switch (key) {
			case 'Unmask PDF Options':
				dispatch(updateMaskUnmaskOptions(params))
				break;
			case 'General Info':
				dispatch(updateGeneralInfo(params))
				break;
			case 'Set Schedule Date Option and Multiple Payer Locations':
				dispatch(updateScheduleDate(params))
				break;
			case 'Support Email Notifications':
				dispatch(updateSupportMail(params))
				break;
			case 'Email-Opt-Out':
				dispatch(saveIsEmailOptOut(params))
				break;
			case 'USPS and Recipient eDelivery Unmask PDF':
				dispatch(saveIsRecipientTinUnMask(params))
				break;
			case 'Forms Routing To USPS Mail':
				dispatch(saveIsFormsRoutingToUSPSMail(params))
				break;
		}
	}

	const renderFieldLabel = (field) => {
		if (field?.Field === GENERAL_SETTINGS.CONSENT_NOT_RESPONDED) {
			const eDeliveryArticleLink = "https://zenwork.my.site.com/SupportTax1099/s/article/1099-Tax-eDelivery-defaults-to-USPS-when-consent-is-requested-but-not-obtained";
			return (
				<span>
					<Label customStyles={styles.fieldLabel}>{field?.Label}</Label>
					<a href={eDeliveryArticleLink}>eDelivery Article</a>
				</span>
			);
		} else {
			return <Label customStyles={styles.fieldLabel}>{field?.Label}</Label>;
		}
	};

	const handleAttachmentsChange = (newAttachment) => {
		setAttachments(newAttachment);
	};

	const getStatusStyles = (status) => {
		return { ...styles.baseStyles, ...styles.statusStyles[status]};
	  };

	return (
		<Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
			<Heading type={HEADING.H1}> General Settings</Heading>
			{fields && Object.keys(fields).map(field =>
				<div style={styles.mainContainer}>
					<div style={styles.flexOne}>
						<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize16}>{field}</Label>
					</div>
					<div style={styles.settingGroup}>
						{fields[field].map(option => <div style={styles.fieldRow}>
							{renderFieldLabel(option)}
							{getInput(option, field)}
						</div>)}
					</div>
					<Button onClickCb={() => handleSubmit(field)}>Save Changes</Button>
					<HorizontalSeparator style={styles.fullWidth} />
				</div>
			)}
			{/* <div style={styles.mainContainer}>
				<div style={styles.flexOne}>
					<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize16}>Upload Sales Tax Exemption Certificate</Label>
				</div>
				<div style={styles.settingGroup}>
					<FormAttachmentUpload
						onChangeCb={handleAttachmentsChange}
						value={attachments}
						name={'Sales Tax Exemption Certificate'}
						addAttachmentBtnLabel={'Upload Certificate'}
						showRemoveBtn={false}
						saveAttachmentBase= 'General'
					/>
					{ salesTaxAdminStatus && 

					<Label customStyles={getStatusStyles(salesTaxAdminStatus)}>
					Status: {salesTaxAdminStatus}
			     	</Label>

					}
				</div>
				<HorizontalSeparator style={styles.fullWidth} />
			</div> */}

			<div style={styles.mainContainer}>
				<div style={styles.flexOne}>
					<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize16}>{`Release Version : ${Config.BUILD_VERSION}`}</Label>
				</div>
				<HorizontalSeparator style={styles.fullWidth} />
			</div>
		</Loadable>
	)
}